"use client";

const items = [
  "Belladonna",
  "Wolfsbane",
  "Eau de Parfum",
  "50ml",
  "Est. MMXXVI",
  "47 Rare Ingredients",
  "12h+ Longevity",
  "Pour Femme",
  "Pour Homme",
];

function Row() {
  return (
    <>
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-8">
          <span className="text-[10px] tracking-[0.35em] uppercase text-[#8a6a2c]/70 whitespace-nowrap">
            {item}
          </span>
          <span className="w-1 h-1 rotate-45 bg-[#c9a84c]/40" aria-hidden="true" />
        </span>
      ))}
    </>
  );
}

export default function Ticker() {
  return (
    <div
      className="relative border-y border-[#221d17]/8 bg-[#f9f6f0] py-4 overflow-hidden"
      aria-hidden="true"
    >
      <div className="marquee-track">
        <div className="flex items-center gap-8 pr-8">
          <Row />
        </div>
        <div className="flex items-center gap-8 pr-8">
          <Row />
        </div>
      </div>
    </div>
  );
}